module.exports = __webpack_public_path__ + "img/communication-active.93464cab.svg";